var React = require('react');

function Carrot (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7 6L0.890909 12L-3.43155e-08 11.215L5.34545 6L-4.90221e-07 0.785047L0.890909 -3.89429e-08L7 6Z","fill":"currentColor"}));
}

Carrot.defaultProps = {"width":"10","height":"15","viewBox":"0 0 7 12","fill":"none"};

module.exports = Carrot;

Carrot.default = Carrot;
